import { Injectable } from '@angular/core';
import { SearchCriterionsDataType } from '../services/client-side-search.service';
import { Criterion } from '../services/base-event-service';

@Injectable({
  providedIn: 'root',
})
export class ClausesSearchCriterionsFactory {
  constructor() {}
  protected readonly entities = {
    [CLAUSES_SEARCH_CRITERION.NAME]: {
      id: CLAUSES_SEARCH_CRITERION.NAME,
      title: 'Clause Name',
      data: ['name'],
      type: SearchCriterionsDataType.String,
      controlName: 'clauseName',
    },
    [CLAUSES_SEARCH_CRITERION.TYPE]: {
      id: CLAUSES_SEARCH_CRITERION.TYPE,
      title: 'Document Type',
      data: ['documentTypes'],
      type: SearchCriterionsDataType.ArrayNumber,
      controlName: 'documentType',
    },
    [CLAUSES_SEARCH_CRITERION.PLAYBOOK]: {
      id: CLAUSES_SEARCH_CRITERION.PLAYBOOK,
      title: 'Playbook',
      data: ['parentPlaybooks'],
      type: SearchCriterionsDataType.ArrayString,
      controlName: 'playbook',
    },
    [CLAUSES_SEARCH_CRITERION.POSITION]: {
      id: CLAUSES_SEARCH_CRITERION.POSITION,
      title: 'My Position',
      data: ['positions'],
      type: SearchCriterionsDataType.ArrayNumber,
      controlName: 'position',
    },
    [CLAUSES_SEARCH_CRITERION.LANGUAGE]: {
      id: CLAUSES_SEARCH_CRITERION.LANGUAGE,
      title: 'Language',
      data: ['languageId'],
      type: SearchCriterionsDataType.Integer,
      controlName: 'languageId',
    },
  };

  getAllItemsAsArray() {
    return Object.values(this.entities) as Criterion[];
  }

  getById(id: number | CLAUSES_SEARCH_CRITERION) {
    const item = { ...this.entities[id as CLAUSES_SEARCH_CRITERION] };
    if (!item) {
      throw new Error(`Unknown id ${id} in ${this.constructor.name}`);
    }
    return item;
  }
}

export enum CLAUSES_SEARCH_CRITERION {
  NAME = 1,
  TYPE = 2,
  PLAYBOOK = 3,
  POSITION = 4,
  LANGUAGE = 5,
}
